import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";

export default function FinalCtaSection() {
  const history = useHistory();

  return (
    <section className="relative overflow-hidden bg-[#012d6e] py-20">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[500px] -translate-x-1/2 rounded-full bg-[#017bef]/20 blur-[64px]" />
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-[250px] w-[400px] -translate-x-1/2 rounded-full bg-[#2563eb]/15 blur-[64px]" />

      <div className="relative mx-auto flex max-w-[768px] flex-col items-center px-[16px] text-center sm:px-8">
        <span className="rounded-full border-[1px] border-solid border-white/15 bg-white/10 px-[16px] py-1.5 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/70">
          One Platform
        </span>
        <h2 className="pt-8 text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-white sm:text-[48px] sm:leading-[60px]">
          One Platform. However You Work, Stay or Play.
        </h2>
        <p className="max-w-[576px] pt-6 text-[18px] leading-[29.25px] text-white/60">
          SPACIA brings flexible workspaces, quality accommodation and curated experiences together so you can spend
          less time searching and more time doing what matters.
        </p>

        <div className="flex flex-wrap justify-center gap-[16px] pt-12">
          <button
            type="button"
            onClick={() => history.push("/package-signup")}
            className="inline-flex items-center gap-2 rounded-full bg-[#017bef] px-8 py-[16px] text-[16px] font-bold leading-6 text-white drop-shadow-[0_4px_12px_rgba(1,123,239,0.3)] transition-colors hover:bg-[#0062c0]"
          >
            Get Started
            <ArrowRight className="size-[18px]" />
          </button>
          <button
            type="button"
            onClick={() => history.push("/partner-signup")}
            className="rounded-full border-[1px] border-solid border-white/20 px-8 py-[16px] text-[16px] font-semibold leading-6 text-white transition-colors hover:bg-white/10"
          >
            List Your Space
          </button>
          <a
            href="mailto:sales@spacia.africa"
            className="inline-flex items-center gap-2 rounded-full border-[1px] border-solid border-white/[0.12] px-8 py-[16px] text-[16px] font-semibold leading-6 text-white/60 no-underline transition-colors hover:bg-white/10 hover:text-white"
          >
            <Mail className="size-4" />
            Speak to Our Team
          </a>
        </div>
      </div>
    </section>
  );
}
